import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { createContext } from "react";
const InfiniteScrollContext = /*#__PURE__*/ createContext(null);
const InfiniteScrollProvider = (t0)=>{
    const $ = c(3);
    const { target, children } = t0;
    const t1 = target || null;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ jsx(InfiniteScrollContext.Provider, {
            value: t1,
            children: children
        });
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
export { InfiniteScrollContext, InfiniteScrollProvider };
